import React, { useState, useRef, useEffect } from "react";
import { Dropdown, Row, Nav, Tab } from "react-bootstrap";
import Select from "react-select";
import PageTitle from "../../layouts/PageTitle";
import { DatePicker } from "rsuite";
import {
  createCaseBookCategory,
  createFaqCategory,
  createPackageType,
  createPlayerSubscription,
  createSessionType,
  getCashBookCategories,
  getFaqCategories,
  getPackageType,
  getPlayerSubscription,
  getSessionType,
} from "../../../services/academicService";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { toHaveDescription } from "@testing-library/jest-dom/matchers";

const theadData = [
  { heading: "S.No.", sortingVale: "sno" },
  { heading: "Category Name", sortingVale: "name" },
  { heading: "Description", sortingVale: "description" },
  { heading: "Actions", sortingVale: "actions" },
];

const CashBookCategory = () => {
  const [iconData, setIconDate] = useState({ complete: false, ind: Number });
  const [subscription, setSubscription] = useState([]);
  const [selectedSessionType, setSelectedPackageType] = useState(null);
  const [editingId, setEditingId] = useState(null);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    description: "",
  });

  function SotingData(name) {
    const sortedPeople = [...subscription];
    switch (name) {
      case "packageType":
        sortedPeople.sort((a, b) => {
          return iconData.complete
            ? a.packageType.localeCompare(b.packageType)
            : b.packageType.localeCompare(a.packageType);
        });
        break;
      case "description":
        sortedPeople.sort((a, b) => {
          return iconData.complete
            ? a.description.localeCompare(b.description)
            : b.description.localeCompare(a.description);
        });
        break;

      default:
        break;
    }
    setSubscription(sortedPeople);
  }

  function DataSearch(e) {
    const updatesDate = subscription.filter((item) => {
      let selectdata = `${item.name} `.toLowerCase();
      return selectdata.includes(e.target.value.toLowerCase());
    });
    setSubscription([...updatesDate]);
  }

  const validate = () => {
    const newErrors = {};

    if (!formData.name.trim()) newErrors.name = "Name is required";

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0; // return true if no errors
  };

  useEffect(() => {
    fetchSessionType();
  }, []);

  async function fetchSessionType() {
    try {
      const res = await getCashBookCategories();
      setSubscription(res);
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) return;

    setLoading(true);

    const payload = {
      name: formData.name,
      description: formData.description,
    };

    // If editing, include id
    if (editingId) {
      payload.id = editingId;
    }

    try {
      const res = await createCaseBookCategory(payload);
      if (res) {
        toast.success(
          editingId
            ? "Updated Category successfully!"
            : "Created Category successfully!",
          {
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          },
        );
        fetchSessionType();
        handleCancel();
      }
    } catch (err) {
      console.error("Error:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const handleCancel = () => {
    setSelectedPackageType(null);
    setFormData({
      name: "",
      description: "",
    });
    setErrors({});
    setEditingId(null);
  };

  return (
    <>
      <PageTitle activeMenu={"All Categories"} motherMenu={"Categories"} />
      <div className="row">
        <div className="col-xl-12 col-xxl-12 col-sm-12">
          <div className="card">
            <div className="card-header">
              <h5 className="card-title">
                Category {editingId ? "Updation" : "Creation"}
              </h5>
            </div>

            <div className="card-body">
              <form>
                <div className="row">
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label className="form-label" htmlFor="name">
                        Category Name <span className="required">*</span>
                      </label>
                      <input
                        id="name"
                        name="name"
                        placeholder="Enter Category Name"
                        type="text"
                        className={`form-control ${
                          errors.name ? "is-invalid" : ""
                        }`}
                        value={formData.name}
                        onChange={handleChange}
                        required
                      />
                      {errors.name && (
                        <small className="text-danger m-lg-2">
                          {errors.name}
                        </small>
                      )}
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label className="form-label" htmlFor="description">
                        Description
                      </label>
                      <input
                        id="description"
                        name="description"
                        placeholder="Enter Description"
                        type="text"
                        className="form-control"
                        value={formData.description}
                        onChange={handleChange}
                        required
                      />
                      {errors.description && (
                        <small className="text-danger m-lg-2">
                          {errors.description}
                        </small>
                      )}
                    </div>
                  </div>

                  {/* Submit */}
                  <div className="col-lg-12 col-md-12 col-sm-12">
                    <button
                      type="submit"
                      className="btn btn-primary me-1"
                      onClick={handleSubmit}
                      disabled={loading}
                    >
                      {loading
                        ? editingId
                          ? "Updating..."
                          : "Submitting..."
                        : editingId
                          ? "Update"
                          : "Submit"}
                    </button>
                    <button
                      type="button"
                      className="btn btn-danger light"
                      onClick={handleCancel}
                    >
                      Reset
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <Row>
        <Tab.Container defaultActiveKey={"List"}>
          <div className="col-lg-12"></div>
          <div className="col-lg-12">
            <Tab.Content className="row tab-content">
              <Tab.Pane eventKey="List" className="col-lg-12">
                <div className="card">
                  <div className="card-header">
                    <h4 className="card-title">Category List</h4>
                  </div>
                  <div className="card-body">
                    <div className="table-responsive">
                      <div
                        id="holidayList"
                        className="dataTables_wrapper no-footer"
                      >
                        <div className="justify-content-between d-sm-flex">
                          <div className="dataTables_length"></div>
                          <div className="dataTables_filter">
                            <label>
                              Search :{" "}
                              <input
                                type="search"
                                className=""
                                placeholder=""
                                onChange={DataSearch}
                              />
                            </label>
                          </div>
                        </div>
                        <table
                          id="example4"
                          className="display dataTable no-footer w-100"
                        >
                          <thead>
                            <tr>
                              {theadData.map((item, ind) => (
                                <th
                                  key={ind}
                                  onClick={() => {
                                    SotingData(item.sortingVale);
                                    setIconDate((prevState) => ({
                                      complete: !prevState.complete,
                                      ind: ind,
                                    }));
                                  }}
                                >
                                  {item.heading}
                                  <span>
                                    {ind !== iconData.ind && (
                                      <i
                                        className="fa fa-sort ms-2 fs-12"
                                        style={{ opacity: "0.3" }}
                                      />
                                    )}
                                    {ind === iconData.ind &&
                                      (iconData.complete ? (
                                        <i
                                          className="fa fa-arrow-down ms-2 fs-12"
                                          style={{ opacity: "0.7" }}
                                        />
                                      ) : (
                                        <i
                                          className="fa fa-arrow-up ms-2 fs-12"
                                          style={{ opacity: "0.7" }}
                                        />
                                      ))}
                                  </span>
                                </th>
                              ))}
                            </tr>
                          </thead>
                          <tbody>
                            {subscription?.map((data, ind) => (
                              <tr key={ind}>
                                <td>{ind + 1}</td>
                                <td>{data?.name}</td>
                                <td>{data?.description}</td>

                                <td>
                                  <button
                                    type="button"
                                    className="btn btn-s sharp btn-primary me-1"
                                    onClick={() => {
                                      setEditingId(data.id);
                                      setFormData({
                                        name: data.name || "",
                                        description: data.description || "",
                                      });

                                      setErrors({});
                                    }}
                                  >
                                    <i className="fa fa-pencil" />
                                  </button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </Tab.Pane>
            </Tab.Content>
          </div>
        </Tab.Container>
      </Row>
    </>
  );
};

export default CashBookCategory;
